import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios"; // Added Axios
import { useParams } from "react-router-dom";
import {
  FaArrowLeft,
  FaStar,
  FaExclamationTriangle,
  FaStarHalfAlt,
  FaBolt,
  FaCheckCircle,
  FaShieldAlt,
  FaMinus,
  FaPlus,
  FaShoppingCart,
  FaHeart,
  FaTruck,
  FaIndustry,
  FaExpand,
  FaLock,
  FaUserCircle,
  FaCalendarAlt,
  FaInfoCircle,
  FaWifi,
  FaWeightHanging,
  FaPhone,
  FaNetworkWired,
} from "react-icons/fa";
import Footer from "./Footer";
import Header from "./header";
import { fetchCart } from "../services/UserService"; // Changed from checkCart to fetchCart
import { FaDownload } from "react-icons/fa6";
import { Helmet } from "react-helmet-async";

const styles = {
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
  },

  textarea: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #CBD5E1",
    resize: "none",
  },

  pageWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    width: "100%",
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    background: "#FFFFFF",
    overflowX: "hidden",
  },
  container: {
    width: "80%",
    maxWidth: "1600px",
    margin: "0 auto",
    padding: "40px 0",
    boxSizing: "border-box",
    animation: "fadeIn 0.5s ease-out forwards",
    flex: "1",
  },
  breadcrumb: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontSize: "14px",
    color: "#64748B",
    marginBottom: "25px",
    flexWrap: "wrap",
  },
  backBtn: {
    background: "white",
    border: "1px solid #E2E8F0",
    padding: "8px 14px",
    borderRadius: "8px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontWeight: "600",
    color: "#475569",
    transition: "0.2s",
  },
  grid: { display: "grid", gap: "60px", alignItems: "start" },
  imageSection: { position: "sticky", top: "100px" },
  mainImageWrapper: {
    width: "100%",
    aspectRatio: "1/1",
    background: "white",
    borderRadius: "24px",
    border: "1px solid #F1F5F9",
    position: "relative",
    overflow: "hidden",
    cursor: "crosshair",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    boxShadow: "0 10px 30px -10px rgba(0,0,0,0.05)",
  },
  mainImage: {
    width: "90%",
    height: "90%",
    objectFit: "contain",
    transition: "transform 0.1s ease-out",
    pointerEvents: "none",
  },
  thumbGrid: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  thumb: {
    width: "70px",
    height: "70px",
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    cursor: "pointer",
    padding: "4px",
    background: "white",
    transition: "0.2s",
    objectFit: "contain",
  },
  thumbActive: {
    borderColor: "rgb(13 67 133)",
    transform: "translateY(-2px)",
    boxShadow: "0 4px 10px rgba(214, 0, 0, 0.2)",
  },
  brandBadge: {
    background: "#FEF2F2",
    color: "rgb(13 67 133)",
    padding: "6px 12px",
    borderRadius: "30px",
    fontSize: "11px",
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    width: "fit-content",
    marginBottom: "15px",
  },
  title: {
    fontSize: "36px",
    fontWeight: "800",
    color: "#0F172A",
    lineHeight: "1.2",
    marginBottom: "15px",
  },
  priceBlock: {
    display: "flex",
    alignItems: "baseline",
    gap: "12px",
    marginBottom: "25px",
    paddingBottom: "25px",
    borderBottom: "1px solid #F1F5F9",
    flexWrap: "wrap",
  },
  price: { fontSize: "42px", fontWeight: "800", color: "#0F172A" },
  mrp: {
    fontSize: "20px",
    textDecoration: "line-through",
    color: "#94A3B8",
    fontWeight: "500",
  },
  discountTag: {
    background: "#DCFCE7",
    color: "#166534",
    padding: "4px 8px",
    borderRadius: "4px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  configHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
  },
  configLabel: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#64748B",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  moqBadge: {
    fontSize: "12px",
    fontWeight: "700",
    color: "#B91C1C",
    background: "#FEF2F2",
    padding: "4px 10px",
    borderRadius: "6px",
    border: "1px solid #FECACA",
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  configGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))",
    gap: "15px",
    marginBottom: "30px",
  },
  configCard: {
    border: "1px solid #E2E8F0",
    borderRadius: "16px",
    padding: "20px 10px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    position: "relative",
    background: "white",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    alignItems: "center",
    textAlign: "center",
  },
  configActive: {
    borderColor: "#D60000",
    background: "#FFF5F5",
    boxShadow: "0 0 0 1px #D60000",
    transform: "translateY(-2px)",
  },
  confName: {
    fontSize: "15px",
    fontWeight: "700",
    color: "#0F172A",
    lineHeight: "1.3",
  },
  confPrice: { fontSize: "15px", color: "#D60000", fontWeight: "800" },
  checkIcon: {
    position: "absolute",
    top: "8px",
    right: "8px",
    color: "#D60000",
    fontSize: "14px",
    background: "white",
    borderRadius: "50%",
  },
  actionArea: {
    display: "flex",
    gap: "15px",
    marginTop: "20px",
    marginBottom: "30px",
    alignItems: "stretch",
    flexWrap: "wrap",
  },
  qtyBox: {
    display: "flex",
    alignItems: "center",
    background: "#F8FAFC",
    borderRadius: "12px",
    border: "1px solid #E2E8F0",
    padding: "0 5px",
  },
  qtyBtn: {
    width: "40px",
    height: "100%",
    background: "transparent",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    color: "#475569",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  qtyVal: {
    width: "30px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "18px",
    color: "#0F172A",
  },
  cartBtn: {
    flex: 1,
    background: "linear-gradient(90deg, rgb(13, 67, 133), rgb(48 113 189))",
    color: "white",
    border: "none",
    borderRadius: "14px",
    fontSize: "18px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    boxShadow: "0 8px 20px -5px rgb(13 67 133)",
    transition: "0.2s",
    padding: "16px",
    minWidth: "200px",
  },
  trustGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "20px",
    background: "#F8FAFC",
    padding: "25px",
    borderRadius: "20px",
    border: "1px solid #E2E8F0",
  },
  trustItem: { display: "flex", gap: "12px", alignItems: "flex-start" },
  trustIcon: {
    color: "#D60000",
    fontSize: "22px",
    marginTop: "2px",
    flexShrink: 0,
  },
  trustTitle: {
    fontSize: "13px",
    fontWeight: "700",
    color: "#0F172A",
    lineHeight: "1.4",
  },
  trustSub: { fontSize: "12px", color: "#64748B" },
  tabs: {
    display: "flex",
    gap: "40px",
    borderBottom: "2px solid #F1F5F9",
    marginTop: "60px",
    marginBottom: "40px",
    overflowX: "auto",
    paddingBottom: "2px",
  },
  tabItem: {
    paddingBottom: "15px",
    cursor: "pointer",
    fontWeight: "600",
    color: "#94A3B8",
    position: "relative",
    fontSize: "16px",
    background: "none",
    border: "none",
    whiteSpace: "nowrap",
    transition: "0.2s",
    borderBottom: "3px solid transparent", // important
  },
  tabActive: {
    color: "rgb(25 103 199)",
    borderBottom: "3px solid rgb(25 103 199)",
    marginBottom: "-2px",
  },
  specContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
    gap: "30px",
  },
  specCard: {
    background: "white",
    padding: "30px",
    borderRadius: "20px",
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 10px rgba(0,0,0,0.02)",
  },
  specHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "25px",
    paddingBottom: "15px",
    borderBottom: "2px solid #F1F5F9",
  },
  specIconBox: {
    width: "40px",
    height: "40px",
    borderRadius: "10px",
    background: "#FEF2F2",
    color: "rgb(13 67 133)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
  },
  specTitle: { fontSize: "17px", fontWeight: "800", color: "#0F172A" },
  specRow: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "14px",
    fontSize: "14px",
    borderBottom: "1px dashed #F1F5F9",
    paddingBottom: "10px",
  },
  specLabel: {
    color: "#64748B",
    fontWeight: "600",
    textTransform: "capitalize",
  },
  specValue: { fontWeight: "700", color: "#334155", textAlign: "right" },
  card: {
    background: "white",
    padding: "35px",
    borderRadius: "24px",
    border: "1px solid #F1F5F9",
    marginBottom: "20px",
  },
  reviewCard: {
    borderBottom: "1px solid #F1F5F9",
    paddingBottom: "25px",
    marginBottom: "25px",
  },
  reviewHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  reviewUser: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontWeight: "700",
    color: "#334155",
  },
};

// --- HELPERS ---
const getVariantName = (fullName) => {
  if (!fullName) return "Standard";
  if (fullName.includes("–")) return fullName.split("–")[1].trim();
  if (fullName.includes("-")) return fullName.split("-")[1].trim();
  return fullName;
};

const normalizePower = (p) => (p ? p.toLowerCase().replace(/\s/g, "") : "");

const ProductDetailsView = ({
  product: propProduct,
  onBack,
  addToCart,
  toggleWishlist,
  isWishlisted,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { productId } = useParams();

  // State
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [addingToCart, setAddingToCart] = useState(false);
  const [details, setDetails] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [qty, setQty] = useState(1);
  const [moq, setMoq] = useState(1);
  const [activeTab, setActiveTab] = useState("specs");
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [zoomStyle, setZoomStyle] = useState({});
  const [isMobile, setIsMobile] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [isWishlistedLocal, setIsWishlistedLocal] = useState(false);
  useEffect(() => {
    if (productId) {
      const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
      setIsWishlistedLocal(wishlist.includes(productId));
    }
  }, [productId]);

  const toggleWishlistLocal = async (product) => {
    const productId = product?.productid || product?.id;
    const productName = product?.productname || product?.name;

    if (!productId) {
      console.error("Invalid Product ID");
      return;
    }

    const userData = JSON.parse(localStorage.getItem("userData") || "{}");
    const USER_ID = userData.email;

    if (!USER_ID) {
      alert("Please login first");
      navigate("/auth");
      return;
    }

    try {
      let wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");

      const isLiked = wishlist.includes(productId);

      let updatedWishlist;

      if (isLiked) {
        // REMOVE
        updatedWishlist = wishlist.filter((id) => id !== productId);
        setIsWishlistedLocal(false);

        await fetch(`${process.env.REACT_APP_API_URL}/remove-from-wishlist`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            product_id: productId,
            user_identifier: USER_ID,
          }),
        });
      } else {
        // ADD
        updatedWishlist = [...wishlist, productId];
        setIsWishlistedLocal(true);

        await fetch(`${process.env.REACT_APP_API_URL}/add-to-wishlist`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            product_id: productId,
            product_name: productName,
            user_identifier: USER_ID,
          }),
        });
      }

      localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
      window.dispatchEvent(new Event("wishlistUpdated"));
    } catch (error) {
      console.error("Wishlist API error:", error);
    }
  };
  // ADD Reviews
  const [reviewerName, setReviewerName] = useState("");
  const [defaultreviewerName, setdefaultReviewerName] = useState("");

  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [images, setImages] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const defaultVariantsRef = React.useRef([]);

  useEffect(() => {
    if (isAuthenticated && productId) {
      fetchDetails(productId);
    }
  }, [isAuthenticated, productId]);

  // --- 1. AUTH CHECK ---
  useEffect(() => {
    const checkAuth = () => {
      setIsAuthenticated(true);
    };
    checkAuth();
  }, [navigate, location]);

  useEffect(() => {
    const resize = () => setIsMobile(window.innerWidth < 1000);
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  useEffect(() => {
    const storedData = localStorage.getItem("userData");

    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setdefaultReviewerName(parsedData.name); // 👈 get name
    }
  }, []);

  if (!isAuthenticated) return null;

  const handleSubmitReview = async () => {
    if (!defaultreviewerName) {
      alert("Please Login");
      navigate("/auth");
      return;
    }
    if (!rating) {
      alert("Please select rating");
      return;
    }

    setSubmitting(true);

    const productIdLocal = productId;

    try {
      const formData = new FormData();
      formData.append("productid", productId);
      formData.append("reviewername", defaultreviewerName);
      formData.append("message", message || "");
      formData.append("rating", rating);

      if (images) {
        images.forEach((img, index) => {
          formData.append("images", img); // backend should accept array of images
        });
      }

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/add-reviews`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (res.data.status) {
        alert("Review added successfully");

        setReviewerName("");
        setMessage("");
        setRating(0);
        setImages([]);

        await fetchDetails(productId);
        setActiveTab("reviews");
      }
    } catch (err) {
      console.error(err);
      alert("Failed to submit review");
    } finally {
      setSubmitting(false);
    }
  };

  const renderStars = (rating, size = 14) => {
    const stars = [];

    for (let i = 1; i <= 5; i++) {
      if (rating >= i) {
        stars.push(<FaStar key={i} size={size} color="#F59E0B" />);
      } else if (rating >= i - 0.5) {
        stars.push(<FaStarHalfAlt key={i} size={size} color="#F59E0B" />);
      } else {
        stars.push(<FaStar key={i} size={size} color="#CBD5E1" />);
      }
    }
    return stars;
  };

  // --- 2. FETCH PRODUCT ---
  const handleMouseMove = (e) => {
    const { left, top, width, height } = e.target.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setZoomStyle({ transformOrigin: `${x}% ${y}%`, transform: "scale(2)" });
  };
  const fetchDetails = async (productId) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/get-products?product_id=${productId}`,
      );
      const result = await response.json();

      if (result.success && result.data) {
        setDetails(result.data);
        setSelectedImage(result.data.imageurl);

        const mainVariant = {
          productid: result.data.productid,
          productname: result.data.productname,
          price: result.data.price,
          power: result.data.power,
          mrp_price: result.data.mrp_price,
          description: result.data.description,
          status: result.data.status,
          about: result.data.about,
          title: result.data.title,
          meta_description: result.data.meta_description,
        };
        setSelectedVariant(mainVariant);
        setMoq(result.data.minimum_quantity);
        setQty(result.data.minimum_quantity || 1);
        setReviews(result.data.reviews || []);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddToCart = async () => {
    setAddingToCart(true);
    try {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const userEmail = userData.email;

      if (!userEmail) {
        navigate("/auth");
        return;
      }

      const productName = selectedVariant.productname;

      // Using fetchCart which should return an object with an 'items' array
      const data = await fetchCart(userEmail);
      const cartItems = data?.items || [];

      const alreadyExists = cartItems.some((item) => item.name === productName);
      const apiPayload = {
        user_identifier: userEmail,
        product_id: selectedVariant.productid,
        quantity: qty,
        product_name: productName,
        price: selectedVariant.price * qty,
        power: selectedVariant.power,
      };

      if (alreadyExists) {
        // 🔁 UPDATE CART
        await axios.post(
          `${process.env.REACT_APP_API_URL}/update-to-addcart`,
          apiPayload,
        );
      } else {
        // ➕ ADD TO CART
        await axios.post(
          `${process.env.REACT_APP_API_URL}/add-to-cart`,
          apiPayload,
        );
      }

      navigate("/cart");
    } catch (error) {
      console.error("Failed to add/update cart:", error);
      navigate("/cart");
    } finally {
      setAddingToCart(false);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          height: "60vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <FaBolt
          className="fa-spin"
          style={{ fontSize: "40px", color: "#D60000" }}
        />
        <style>{`@keyframes spin { 100% { transform: rotate(360deg); } } .fa-spin { animation: spin 1s infinite linear; }`}</style>
      </div>
    );
  }

  if (!details) {
    return <div>Data Error</div>;
  }

  // ✅ Now it's safe to use details
  const targetPower = normalizePower(details.power);
  const rawVariants = [
    {
      productid: details.productid,
      productname: details.productname,
      price: details.price,
      power: details?.power,
      mrp_price: details.mrp_price,
    },
    ...(details.variants || []),
  ];

  const filteredVariants = rawVariants.filter(
    (v) => normalizePower(v.power) === targetPower,
  );

  if (defaultVariantsRef.current.length === 0 && filteredVariants.length > 0) {
    defaultVariantsRef.current.push(...filteredVariants);
  }

  const Default_variants = defaultVariantsRef.current;
  const rawSpecs = details.specifications?.[0] || {};
  const company = details.company?.[0] || {};
  const shipping = details.shipping || {};

  const electricalSpecs = Object.entries(rawSpecs).filter(([k]) =>
    /product_type|voltage|current|power|frequency|energy|capacity|ev_served/i.test(
      k,
    ),
  );
  const smartSpecs = Object.entries(rawSpecs).filter(([k]) =>
    /wifi|gsm|rfid|auth|connect|communicat|protocol|language|indicator|led|app|cable_length|user_interface/i.test(
      k,
    ),
  );
  const mechSpecs = Object.entries(rawSpecs).filter(([k]) =>
    /weight|ingress|ip|ik|temp|humid|altitude|mount|safety|emergency|protection/i.test(
      k,
    ),
  );
  const stockStatus = selectedVariant?.status ?? details?.status;
  const slugify = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  };
  return (
    <>
      <Helmet>
        <title>{details?.title}</title>

        <meta name="description" content={details?.meta_description} />

        <meta
          name="keywords"
          content={`EV charger, ${details?.productname || ""}, ${details?.power?.toLowerCase() || ""}, electric vehicle charger India`}
        />
        
        {/* Open Graph (for WhatsApp, Facebook) */}
        <meta property="og:title" content={details?.productname} />
        <meta
          property="og:description"
          content={`Buy ${details?.meta_description} online at best price.`}
        />
        <meta property="og:image" content={details?.imageurl} />
        <meta property="og:type" content="product" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={details?.productname} />
        <meta
          name="twitter:description"
          content={`Buy ${details?.meta_description} with warranty and fast delivery.`}
        />
        <meta name="twitter:image" content={details?.imageurl} />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href={`https://cgrmart.com/product-details/${productId}`}
        />
      </Helmet>
      <Header />
      <div style={styles.pageWrapper}>
        <div style={styles.container}>
          <div style={styles.breadcrumb}>
            <button onClick={onBack} style={styles.backBtn}>
              <FaArrowLeft /> Back
            </button>
            <span>
              Home / {details.Type} /{" "}
              <span style={{ color: "#0F172A", fontWeight: "bold" }}>
                {details.productname}
              </span>
            </span>
          </div>

          <div
            style={{
              ...styles.grid,
              gridTemplateColumns: isMobile ? "1fr" : "1fr 1.2fr",
            }}
          >
            {/* LEFT: IMAGE */}
            <div style={styles.imageSection}>
              <div
                style={styles.mainImageWrapper}
                onMouseMove={handleMouseMove}
                onMouseLeave={() => setZoomStyle({ transform: "scale(1)" })}
              >
                <img
                  src={selectedImage}
                  alt="Product"
                  style={{ ...styles.mainImage, ...zoomStyle }}
                />
              </div>
              <span
                style={{
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "rgb(15, 23, 42)",
                }}
              >
                <b>Note:</b> Product images are for illustrative purposes only.
                The final product may vary in appearance.
              </span>
              <div
                style={{
                  ...styles.thumbGrid,
                  marginTop: "10px", // ✅ correct way to merge styles
                }}
              >
                {[
                  details.imageurl,
                  details.pro_img1,
                  details.pro_img2,
                  details.pro_img3,
                  details.pro_img4,
                  details.pro_img5,
                  details.pro_img6,
                ]
                  .filter(Boolean)
                  .map((img, i) => (
                    <img
                      key={i}
                      src={img}
                      alt="thumb"
                      style={{
                        ...styles.thumb,
                        ...(selectedImage === img ? styles.thumbActive : {}),
                      }}
                      onClick={() => setSelectedImage(img)}
                    />
                  ))}
              </div>
            </div>

            {/* RIGHT: INFO */}
            <div>
              <h1 style={styles.title}>{details.productname.split("–")[0]}</h1>

              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  alignItems: "center",
                  marginBottom: "25px",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ display: "flex", gap: "4px" }}>
                  {renderStars(Number(details.average_rating || 0), 14)}
                </div>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#64748B",
                  }}
                >
                  {details.average_rating} ({reviews.length} Reviews)
                </span>
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: stockStatus === "1" ? "#10B981" : "#EF4444",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  {stockStatus === "1" ? (
                    <>
                      <FaCheckCircle /> In Stock
                    </>
                  ) : (
                    <>
                      <FaExclamationTriangle /> Out of Stock
                    </>
                  )}
                </span>
              </div>

              {!["120kw", "240kw", "60kw"].includes(
                details?.power?.toLowerCase().replace(/\s/g, ""),
              ) ? (
                <div style={styles.priceBlock}>
                  {/* PRICE */}
                  <div style={styles.price}>
                    ₹
                    {Number(
                      selectedVariant?.price ?? details?.price ?? 0,
                    ).toLocaleString()}
                  </div>

                  {/* MRP & DISCOUNT */}
                  {Number(
                    selectedVariant?.mrp_price ?? details?.mrp_price ?? 0,
                  ) > Number(selectedVariant?.price ?? details?.price ?? 0) && (
                    <>
                      <div style={styles.mrp}>
                        ₹
                        {Number(
                          selectedVariant?.mrp_price ?? details?.mrp_price ?? 0,
                        ).toLocaleString()}
                      </div>

                      <div style={styles.discountTag}>
                        {Math.round(
                          ((Number(
                            selectedVariant?.mrp_price ??
                              details?.mrp_price ??
                              0,
                          ) -
                            Number(
                              selectedVariant?.price ?? details?.price ?? 0,
                            )) /
                            Number(
                              selectedVariant?.mrp_price ??
                                details?.mrp_price ??
                                1,
                            )) *
                            100,
                        )}
                        % OFF
                      </div>
                    </>
                  )}
                </div>
              ) : null}
              {/* Configuration */}
              <div>
                <div style={styles.configHeader}>
                  <div style={styles.configLabel}>
                    Choose Configuration ({details?.power})
                  </div>
                  {moq > 1 && (
                    <div style={styles.moqBadge}>
                      <FaInfoCircle size={10} /> Min Order: {moq}
                    </div>
                  )}
                </div>

                <div style={styles.configGrid}>
                  {Default_variants.map((v) => {
                    const isSelected =
                      selectedVariant?.productid === v.productid;
                    const shortName = getVariantName(v.productname);
                    return (
                      <div
                        key={v.productid}
                        style={{
                          ...styles.configCard,
                          ...(isSelected ? styles.configActive : {}),
                        }}
                        onClick={() =>
                          navigate(
                            `/product-details/${slugify(v.productname)}/${v.productid}`,
                          )
                        }
                      >
                        {isSelected && (
                          <FaCheckCircle style={styles.checkIcon} />
                        )}
                        <div style={styles.confName}>{shortName}</div>
                        {!["120kw", "240kw", "60kw"].includes(
                          details?.power?.toLowerCase().replace(/\s/g, ""),
                        ) ? (
                          <div style={styles.confPrice}>
                            ₹{Number(v.price).toLocaleString()}
                          </div>
                        ) : null}
                      </div>
                    );
                  })}

                  {["120kw", "240kw", "60kw"].includes(
                    details?.power?.toLowerCase().replace(/\s/g, ""),
                  ) ? (
                    <div
                      style={{
                        width: "100%",
                        marginTop: "8px",
                        padding: "12px",
                        borderRadius: "10px",
                        background: "linear-gradient(135deg, #208b20, #92f59b)",
                        color: "#fff",
                        fontWeight: "700",
                        fontSize: "13px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "6px",
                        boxShadow: "0 6px 15px rgba(0,0,0,0.15)",
                        cursor: "pointer",
                      }}
                    >
                      {/* Title */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <FaPhone />
                        Get Best Price
                      </div>

                      {/* Phone Number (Clickable) */}
                      <a
                        href="tel:+918220057752"
                        style={{
                          color: "#fff",
                          fontSize: "14px",
                          fontWeight: "800",
                          textDecoration: "none",
                          letterSpacing: "0.5px",
                        }}
                      >
                        +91 82200 57752
                      </a>

                      {/* Sub Text */}
                      <span
                        style={{
                          fontSize: "11px",
                          fontWeight: "500",
                          opacity: 0.9,
                        }}
                      >
                        Tap to Call Sales Team
                      </span>
                    </div>
                  ) : null}
                </div>
              </div>

              <div
                style={{
                  fontSize: "13px",
                  color: "#64748B",
                  marginTop: "5px",
                  lineHeight: "1.5",
                }}
              >
                <b>Description:</b>{" "}
                {selectedVariant?.description ||
                  details?.productInfo?.description ||
                  "No description available"}
              </div>

              {/* Actions */}
              {!["120kw", "240kw", "60kw"].includes(
                details?.power?.toLowerCase().replace(/\s/g, ""),
              ) ? (
                <div style={styles.actionArea}>
                  <div style={styles.qtyBox}>
                    <button
                      onClick={() => setQty(Math.max(moq, qty - 1))}
                      style={styles.qtyBtn}
                    >
                      <FaMinus />
                    </button>
                    <div style={styles.qtyVal}>{qty}</div>
                    <button
                      onClick={() => {
                        // Check if product name includes "dc" and limit qty to 5
                        const isDC = details.productname
                          .toLowerCase()
                          .includes("dc");
                        const maxQty = isDC ? 5 : Infinity; // 5 for DC, no limit otherwise
                        setQty(Math.min(maxQty, qty + 1));
                      }}
                      style={styles.qtyBtn}
                    >
                      <FaPlus />
                    </button>
                  </div>

                  <button
                    onClick={handleAddToCart}
                    disabled={addingToCart || stockStatus !== "1"}
                    style={{
                      ...styles.cartBtn,
                      opacity: addingToCart || stockStatus !== "1" ? 0.7 : 1,
                      cursor: stockStatus === "1" ? "pointer" : "not-allowed",
                    }}
                  >
                    {addingToCart ? (
                      "Adding..."
                    ) : stockStatus === "1" ? (
                      <>
                        <FaShoppingCart /> Add to Cart
                      </>
                    ) : (
                      "Out of Stock"
                    )}
                  </button>
                  <button
                    onClick={() => toggleWishlistLocal(details)}
                    style={{
                      width: "60px",
                      borderRadius: "14px",
                      borderColor: "#D60000",
                      background: isWishlistedLocal ? "#FEF2F2" : "white",
                      color: isWishlistedLocal ? "#D60000" : "#64748B",
                      fontSize: "20px",
                      cursor: "pointer",
                    }}
                  >
                    <FaHeart />
                  </button>
                </div>
              ) : (
                <div></div>
              )}

              <div
                style={{
                  marginTop: "25px",
                  borderRadius: "16px",
                  border: "1px solid #E2E8F0",
                  background: "#fff",
                  padding: "18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "15px",
                  flexWrap: "wrap",
                  boxShadow: "0 6px 18px rgba(0,0,0,0.04)",
                }}
              >
                <div style={{ flex: 1, minWidth: "220px" }}>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "800",
                      color: "#0F172A",
                    }}
                  >
                    🚀 Bulk Purchase Available
                  </div>

                  <div
                    style={{
                      fontSize: "13px",
                      color: "#64748B",
                      marginTop: "5px",
                      lineHeight: "1.5",
                    }}
                  >
                    Special pricing for bulk orders with GST billing & dedicated
                    support.
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                  }}
                >
                  <button
                    onClick={() => navigate("/contactus")}
                    style={{
                      padding: "10px 16px",
                      borderRadius: "8px",
                      border: "1px solid rgb(13 67 133)",
                      background:
                        "linear-gradient(90deg, rgb(13, 67, 133), rgb(48 113 189))",
                      color: "#fff",
                      fontWeight: "700",
                      cursor: "pointer",
                    }}
                  >
                    Enquire Now
                  </button>

                  <a
                    href="tel:+918220057752"
                    style={{
                      padding: "10px 14px",
                      borderRadius: "8px",
                      border: "1px solid #E2E8F0",
                      background: "#F8FAFC",
                      color: "#0F172A",
                      fontWeight: "600",
                      textDecoration: "none",
                    }}
                  >
                    📞 Call
                  </a>
                </div>
              </div>
              <br></br>
              {/* Trust Badges */}
              <div style={styles.trustGrid}>
                <div style={styles.trustItem}>
                  <FaTruck style={styles.trustIcon} />
                  <div>
                    <div style={styles.trustTitle}>
                      Delivery: {shipping.delivery} Days
                    </div>
                    <div style={styles.trustSub}>Across {company.location}</div>
                  </div>
                </div>
                <div style={styles.trustItem}>
                  <FaShieldAlt style={styles.trustIcon} />
                  <div>
                    <div style={styles.trustTitle}>
                      {shipping.warranty} Year Warranty
                    </div>
                    <div style={styles.trustSub}>Full Coverage</div>
                  </div>
                </div>
                <div style={styles.trustItem}>
                  <FaLock style={styles.trustIcon} />
                  <div>
                    <div style={styles.trustTitle}>Secure Transaction</div>
                    <div style={styles.trustSub}>Verified by Razorpay</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={styles.tabs}>
            <button
              style={{
                ...styles.tabItem,
                ...(activeTab === "specs" ? styles.tabActive : {}),
              }}
              onClick={() => setActiveTab("specs")}
            >
              Specifications
            </button>
            <button
              style={{
                ...styles.tabItem,
                ...(activeTab === "features" ? styles.tabActive : {}),
              }}
              onClick={() => setActiveTab("features")}
            >
              Key Features
            </button>
            <button
              style={{
                ...styles.tabItem,
                ...(activeTab === "reviews" ? styles.tabActive : {}),
              }}
              onClick={() => setActiveTab("reviews")}
            >
              Reviews ({reviews.length})
            </button>
            <button
              style={{
                ...styles.tabItem,
                ...(activeTab === "datasheet" ? styles.tabActive : {}),
              }}
              onClick={() => setActiveTab("datasheet")}
            >
              Datasheet
            </button>
            <button
              style={{
                ...styles.tabItem,
                ...(activeTab === "about_products" ? styles.tabActive : {}),
              }}
              onClick={() => setActiveTab("about_products")}
            >
              About
            </button>
          </div>

          <div>
            {/* Specifications */}
            {activeTab === "specs" && (
              <div style={styles.specContainer}>
                {electricalSpecs.length > 0 && (
                  <div style={styles.specCard}>
                    <div style={styles.specHeader}>
                      <div style={styles.specIconBox}>
                        <FaBolt />
                      </div>
                      <span style={styles.specTitle}>
                        Electrical Performance
                      </span>
                    </div>
                    {electricalSpecs.map(([k, v]) => {
                      const label =
                        k.toLowerCase() === "ev_served"
                          ? "Connector"
                          : k.replace(/_/g, " ");

                      return (
                        <div key={k} style={styles.specRow}>
                          <span style={styles.specLabel}>{label}</span>
                          <span style={styles.specValue}>{v}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
                {smartSpecs.length > 0 && (
                  <div style={styles.specCard}>
                    <div style={styles.specHeader}>
                      <div style={styles.specIconBox}>
                        <FaWifi />
                      </div>
                      <span style={styles.specTitle}>Smart & Connectivity</span>
                    </div>
                    {smartSpecs.map(([k, v]) => (
                      <div key={k} style={styles.specRow}>
                        <span style={styles.specLabel}>
                          {k.replace(/_/g, " ")}
                        </span>
                        <span style={styles.specValue}>{v}</span>
                      </div>
                    ))}
                  </div>
                )}
                {mechSpecs.length > 0 && (
                  <div style={styles.specCard}>
                    <div style={styles.specHeader}>
                      <div style={styles.specIconBox}>
                        <FaWeightHanging />
                      </div>
                      <span style={styles.specTitle}>Mechanical & Build</span>
                    </div>
                    {mechSpecs.map(([k, v]) => (
                      <div key={k} style={styles.specRow}>
                        <span style={styles.specLabel}>
                          {k.replace(/_/g, " ")}
                        </span>
                        <span style={styles.specValue}>{v}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeTab === "features" && (
              <div
                style={{
                  ...styles.card,
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
                  gap: "20px",
                }}
              >
                {details.productInfo?.keyfeature?.map((feat, i) => (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      gap: "15px",
                      alignItems: "start",
                    }}
                  >
                    <FaCheckCircle
                      style={{
                        color: "#10B981",
                        flexShrink: 0,
                        marginTop: "4px",
                        fontSize: "18px",
                      }}
                    />
                    <span
                      style={{
                        color: "#334155",
                        lineHeight: "1.6",
                        fontSize: "15px",
                      }}
                    >
                      {feat}
                    </span>
                  </div>
                ))}
              </div>
            )}

            {activeTab === "company" && (
              <div style={styles.card}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    marginBottom: "25px",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      background: "#FEF2F2",
                      color: "#D60000",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "32px",
                    }}
                  >
                    <FaIndustry />
                  </div>
                  <div>
                    <h2
                      style={{
                        margin: 0,
                        color: "#0F172A",
                        fontSize: "24px",
                      }}
                    >
                      {company.company_name}
                    </h2>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#64748B",
                        marginTop: "5px",
                      }}
                    >
                      {company.type} • Est. {company.founding_year}
                    </div>
                  </div>
                </div>
                <p
                  style={{
                    lineHeight: "1.8",
                    color: "#475569",
                    maxWidth: "900px",
                    fontSize: "15px",
                  }}
                >
                  {company.description}
                </p>
              </div>
            )}

            {activeTab === "datasheet" && (
              <div style={styles.card}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                    marginBottom: "25px",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      background: "#FEF2F2",
                      color: "#D60000",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "32px",
                    }}
                  >
                    <FaDownload />
                  </div>
                  <div>
                    <div
                      style={{
                        fontSize: "14px",
                        color: "#64748B",
                        marginTop: "5px",
                      }}
                    >
                      Product images are for illustrative purposes only. The
                      final product may vary in appearance. For complete
                      specifications, please refer to the datasheet.
                    </div>
                    <a
                      href={details.productInfo?.datasheet}
                      target="_blank"
                      rel="noopener noreferrer"     
                      style={{
                        display: "inline-block",
                        marginTop: "10px",
                        color: "#D60000",
                        fontWeight: "bold",
                        textDecoration: "none",
                      }}
                    >
                      Download Datasheet
                    </a>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "reviews" && (
              <div style={styles.card}>
                <h3
                  style={{
                    marginTop: 0,
                    marginBottom: "25px",
                    color: "#0F172A",
                  }}
                >
                  Customer Reviews
                </h3>
                {reviews.length > 0 ? (
                  reviews.map((r) => (
                    <div key={r.review_id} style={styles.reviewCard}>
                      <div style={styles.reviewHeader}>
                        <div style={styles.reviewUser}>
                          <FaUserCircle
                            style={{ fontSize: "36px", color: "#CBD5E1" }}
                          />
                          <span style={{ fontSize: "16px" }}>
                            {r.reviewername}
                          </span>
                        </div>
                        <div
                          style={{
                            fontSize: "13px",
                            color: "#94A3B8",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <FaCalendarAlt />{" "}
                          {new Date(r.created_at).toLocaleDateString()}
                        </div>
                        {/* Render review images */}
                        {(r.images || (r.image ? [r.image] : [])).length >
                          0 && (
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns:
                                "repeat(auto-fill, minmax(80px, 1fr))",
                              gap: "8px",
                              marginTop: "8px",
                            }}
                          >
                            {(r.images || (r.image ? [r.image] : [])).map(
                              (img, idx) => (
                                <div
                                  key={idx}
                                  style={{
                                    width: "100%",
                                    paddingBottom: "100%", // makes it square
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    border: "1px solid #E2E8F0",
                                  }}
                                  onClick={() => window.open(img, "_blank")} // optional: click to enlarge
                                >
                                  <img
                                    src={img}
                                    alt="review"
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                </div>
                              ),
                            )}
                          </div>
                        )}
                      </div>
                      <div style={{ display: "flex", gap: "4px" }}>
                        {renderStars(Number(r.rating), 14)}
                      </div>

                      <p
                        style={{
                          color: "#475569",
                          margin: 0,
                          lineHeight: "1.6",
                        }}
                      >
                        {r.message}
                      </p>
                    </div>
                  ))
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      color: "#94A3B8",
                    }}
                  >
                    <p>No reviews yet.</p>
                  </div>
                )}
                <div style={{ ...styles.card, marginBottom: "24px" }}>
                  <h3
                    style={{
                      marginTop: 0,
                      marginBottom: "16px",
                      color: "#0F172A",
                    }}
                  >
                    Add Your Review
                  </h3>

                  {/* Name */}
                  <input
                    type="text"
                    value={defaultreviewerName}
                    readOnly
                    style={{ ...styles.input, display: "none" }} // or remove display:none if you want visible
                  />

                  {/* Rating */}
                  <div
                    style={{
                      display: "flex",
                      gap: "6px",
                      marginBottom: "12px",
                    }}
                  >
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          const rect = e.currentTarget.getBoundingClientRect();
                          const isHalf = e.clientX - rect.left < rect.width / 2;
                          setRating(isHalf ? star - 0.5 : star);
                        }}
                        onMouseMove={(e) => {
                          const rect = e.currentTarget.getBoundingClientRect();
                          const isHalf = e.clientX - rect.left < rect.width / 2;
                          setHoverRating(isHalf ? star - 0.5 : star);
                        }}
                        onMouseLeave={() => setHoverRating(0)}
                      >
                        {renderStars(hoverRating || rating, 22)[star - 1]}
                      </span>
                    ))}
                  </div>

                  {/* Message */}
                  <textarea
                    placeholder="Write your review..."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={4}
                    style={styles.textarea}
                  />

                  {/* Image Upload */}
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => setImages(Array.from(e.target.files))} // store multiple images
                    style={{ marginBottom: "14px" }}
                  />

                  {/* Submit */}
                  <button
                    onClick={handleSubmitReview}
                    disabled={submitting}
                    style={{
                      padding: "10px 18px",
                      borderRadius: "8px",
                      border: "none",
                      background: "#0F172A",
                      color: "#fff",
                      cursor: "pointer",
                    }}
                  >
                    {submitting ? "Submitting..." : "Submit Review"}
                  </button>
                </div>
              </div>
            )}
            {activeTab === "about_products" && (
              <div style={styles.card}>
                <div
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.6",
                    color: "#444",
                    marginBottom: "15px",
                    textAlign: "justify",
                  }}
                >
                  {details?.about}
                </div>
              </div>
            )}
          </div>
        </div>
        <Footer />
      </div>
      {/* } */}
    </>
  );
};

export default ProductDetailsView;
